export default __webpack_public_path__ + "static/media/error.fdedfc9e.svg";